import React from 'react'
import { Container } from 'reactstrap'

import SearchHome from '../../Search/SearchHome'

const SearchSection = () => {
	return (
		<section 
			className="home-slice home-slice-search"
			role="region"
			aria-label="Section de recherche de la page d'accueil"
			aria-labelledby="search-section-heading"
		>
			<Container>
				<h2 id="search-section-heading" className="visually-hidden">
					Recherche et assistance
				</h2>
				<SearchHome SearchTitle="Comment pouvons-nous vous aider ?" />
			</Container>
		</section>
	)
}

export default SearchSection
